import type {
  CrmIntegrationMessage,
  CrmIntegrationMessageDelivery,
  CrmIntegrationMessageDeliveryStatus,
} from '../types/crm-integration-chat.types'
import { normalizeCrmIntegrationAttachments } from './crmIntegrationAttachment'
import type {
  CrmIntegrationMessageDeliveryView,
  CrmIntegrationMessageDeliveryViewStatus,
  CrmIntegrationMessageView,
} from '../types/crm-integration-message.types'

const mapDeliveryStatus = (
  status: CrmIntegrationMessageDeliveryStatus,
): CrmIntegrationMessageDeliveryViewStatus => {
  if (status === 'sent' || status === 'failed' || status === 'pending') {
    return status
  }
  return 'pending'
}

export const mapCrmIntegrationMessageDelivery = (
  delivery: CrmIntegrationMessageDelivery,
): CrmIntegrationMessageDeliveryView => ({
  status: mapDeliveryStatus(delivery.status),
  error: delivery.error,
  deliveredAt: delivery.delivered_at,
})

export const mapCrmIntegrationMessage = (
  item: CrmIntegrationMessage,
): CrmIntegrationMessageView => {
  const senderNameRaw =
    item.sender && typeof item.sender === 'object'
      ? String(item.sender.name ?? '').trim()
      : ''

  return {
    id: item.id,
    conversationId: item.conversation_id,
    direction: item.direction,
    text: item.text?.trim() ? item.text : item.message_text,
    createdAt: item.created_at,
    isRead: item.is_read === 1,
    delivery: mapCrmIntegrationMessageDelivery(item.delivery),
    attachments: normalizeCrmIntegrationAttachments(item.attachments),
    senderName: senderNameRaw || null,
    providerMessageId:
      item.provider_message_id != null
        ? String(item.provider_message_id)
        : null,
    externalMessageId:
      item.external_message_id != null
        ? String(item.external_message_id)
        : null,
  }
}

export const mapCrmIntegrationMessages = (
  items: CrmIntegrationMessage[],
): CrmIntegrationMessageView[] => items.map(mapCrmIntegrationMessage)
